export type CatalogSearchRouteContext =
    | { type: 'global' }
    | { type: 'property-catalog'; isInventory: boolean };

export const getCatalogSearchRouteContext = (
    pathname: string,
): CatalogSearchRouteContext | null => {
    if (pathname.includes('/orders/add-items/marketplace')) {
        return { type: 'global' };
    }

    if (pathname.startsWith('/orders/add-items/categories')) {
        return { type: 'property-catalog', isInventory: false };
    }

    const propertyCatalogMatch = pathname.match(
        /^\/properties\/[^/]+\/catalog(?:\/(.*))?$/,
    );

    if (!propertyCatalogMatch) {
        return null;
    }

    const catalogPath = propertyCatalogMatch[1] ?? '';

    if (catalogPath.startsWith('global')) {
        return { type: 'global' };
    }

    if (catalogPath.startsWith('inventory')) {
        return { type: 'property-catalog', isInventory: true };
    }

    return { type: 'property-catalog', isInventory: false };
};

export const isCatalogSearchRoute = (pathname: string): boolean =>
    getCatalogSearchRouteContext(pathname) !== null;
